import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { DayjsModule, SharedModule } from '@leandredev/common_ng_14';

import { RentReportMonthlyFormModule } from '../../form/RentReportMonthly/RentReportMonthly.module';

import { RentReportMonthlyUIListSubDocComponent } from './RentReportMonthly.component';

@NgModule({
  declarations: [RentReportMonthlyUIListSubDocComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatExpansionModule,
    MatInputModule,
    DayjsModule,
    SharedModule,
    MatButtonModule,
    MatMenuModule,
    DragDropModule,

    RentReportMonthlyFormModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatExpansionModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule,
    DragDropModule,
    DayjsModule,
    SharedModule,

    RentReportMonthlyFormModule,

    RentReportMonthlyUIListSubDocComponent
  ]
})
export class RentReportMonthlyListSubDocModule {}
